import { render, staticRenderFns } from "./editar.vue?vue&type=template&id=acee0260&"
import script from "./editar.vue?vue&type=script&lang=ts&"
export * from "./editar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports